var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickOnlineLogoQ(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 453.01 437.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea002a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3_white",
    "data-name": "3_white"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M453,171.77v-.43c0-30.38-9.1-58.92-25-83.65l-74.46,71.64a84.07,84.07,0,0,1,1.06,13.13c0,49.23-43.83,89.13-97.9,89.13-3.05,0-6.09-.12-9.06-.38l-69.87,67.24a220.9,220.9,0,0,0,78.54,14.24c81.66,0,151.67-43.33,181.44-105,0,0,7.44-12.91,12.19-33.67C453.2,189.64,453,171.77,453,171.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.28,0C147.66,0,59.55,76.71,59.55,171.34c0,41.27,16.74,79,44.6,108.6L42.9,339l17.91,6.53L30.54,379.7,51,385.42,0,437.11,130.85,379.7l-20-7.15L160.65,339l-20.42-5.13,136.59-130H183.17L171,215.54a82.5,82.5,0,0,1-12.25-43.08c0-49.24,43.85-89.17,97.93-89.17,39.76,0,74,21.62,89.29,52.62l68.75-66.14C378.88,27.44,321.27,0,256.28,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickOnlineLogoQ);
export default __webpack_public_path__ + "static/media/quick-online-logo-q.bc54f70f9ed4a168a686a96f6ee55457.svg";
export { ForwardRef as ReactComponent };